module.exports = __webpack_public_path__ + "img/wael.45457e6e.jpeg";